import React, { memo, useCallback, useState } from 'react';
import { Button } from '@Sage/hoi-poi-ui';

import AbsoluteEmpty from 'components/AbsoluteEmpty';
import VideoModal from 'components/VideoModal';
import { getLiteral } from 'utils/getLiteral';

import './AutomationsListEmptyView.scss';

const AutomationsListEmptyView = memo(({ emptyViewProps }) => {
    const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

    const handleOpenVideoModal = useCallback(() => {
        setIsVideoModalOpen(true);
    }, []);

    const handleCloseVideoModal = useCallback(() => {
        setIsVideoModalOpen(false);
    }, []);

    return (
        <div className="fm-automation-settings__empty-view">
            <AbsoluteEmpty
                actions={[
                    emptyViewProps.onCreate ? (
                        <Button type="secondary" onClick={emptyViewProps.onCreate}>
                            {getLiteral('action_automation_create')}
                        </Button>
                    ) : null,
                    emptyViewProps.onTemplates ? (
                        <Button type="secondary" onClick={emptyViewProps.onTemplates}>
                            {getLiteral('action_automation_create_from_template')}
                        </Button>
                    ) : null,
                ]}
                imageOverride={
                    <img
                        className="fm-automations-empty-image"
                        onClick={handleOpenVideoModal}
                        src="/images/empty-automations-image.webp"
                    />
                }
                subtitle={getLiteral('label_automations_empty_page_desc')}
                title={getLiteral('label_automations_empty_page')}
            />
            <VideoModal
                isOpen={isVideoModalOpen}
                onRequestClose={handleCloseVideoModal}
                title={getLiteral('action_automations_video_tutorial_intro')}
                videoUrl={getLiteral('label_automations_video_tutorial_intro_link')}
            />
        </div>
    );
});

AutomationsListEmptyView.displayName = 'AutomationsListEmptyView';

export default AutomationsListEmptyView;
